import _ from 'underscore';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import DraftModel from '@/models/v5/draft';

const DraftsCollection = v5_Collection.extend({
    initialize: function(collection, options) {
        this.product = options.product;
    },
    fetch: function(options) {
        options = options || {};
        options = _.extend({
            reset: true
        }, options);

        return v5_Collection.prototype.fetch.call(this, options);
    },
    url: function() {
        return Api.urls.drafts({
            product_id: this.product.id
        });
    },
    model: DraftModel
});

export default DraftsCollection;

